export enum RepoChatDropdownMenuLabels{
    NEW_CHAT = 'New Chat',
    SAVED_PROMPTS = 'Prompt library',
    HISTORY = 'History',
    SOURCE_UPDATED = 'Source updated:',
    ABOUT_REPOSITORY = 'About repository',
    REPOSITORY_SETTINGS = 'Repository settings'
}